<div class="control-card-white">
    <div class="control-card-header">
        <ng-container i18n="@@search_by_method_title">Ricerca utente per metodo d'accesso</ng-container>
        <fa-icon icon="times" class="float-right margin-right-20 icon-clickable" (click)="closeDialog()"></fa-icon>
    </div>

    <div class="control-card-content">
        <form [formGroup]="searchByMethodForm">
            <table class="simple-table">

                <tr>
                    <td width="250px" class="text-dark" i18n="@@search_by_method_type">Tipo :</td>
                    <td> <select width="450px" formControlName="type" [(ngModel)]="type">
                            <option *ngFor="let type of accessMethodTypes" [ngValue]="type">
                                {{ type.text }}
                            </option>
                        </select></td>
                </tr>

                <tr>
                    <td width="250px" class="text-dark" i18n="@@search_by_method_code">Codice :</td>


                    <td *ngIf="type != accessMethodTypes[2]">
                        <input id="code-input" formControlName="code" type="text" [(ngModel)]="code" width="450px" />
                    </td>

                    <td *ngIf="type == accessMethodTypes[2]">
                        <div>
                            <select formControlName="prefix" style="width: 250px;" [(ngModel)]="prefix">
                                <option *ngFor="let prefix of prefixes" [ngValue]="prefix">
                                    {{prefix.text}}
                                </option>
                            </select>
                            <input formControlName="code" type="text" [(ngModel)]="code" style="width: 200px;" />
                        </div>
                    </td>

                </tr>

            </table>

        </form>

        <div class="resultDiv bordered padding-top-25 padding-bottom-25" *ngIf="userFound == FOUND">
            <p class="resultP" i18n="@@search_by_method_linked_to_user">
                Metodo associato all'utente:
            </p>
            <a (click)="openUserPage()" class="display-block align-center margin-top-30 clickable">
                <ng-container>{{ resultName }}</ng-container>
            </a>

        </div>

        <div class="resultDivError bordered" *ngIf="userFound == NOT_FOUND">
            <p class="resultP text-small text-error padding-top-25" i18n="@@search_by_method_no_user_found_error">Nessun
                utente associato a questo metodo d'accesso</p>
        </div>

    </div>

    <div class="control-card-buttons">

        <a (click)="search()" class="button">
            <ng-container i18n="@@search_by_method_search">Cerca</ng-container>
            <span>
                <fa-icon icon="search"></fa-icon>
            </span>
        </a>
        <a (click)="closeDialog()" class="button button-red" id="cancelButton">
            <ng-container i18n="@@search_by_method_cancel">Annulla</ng-container>
            <span>
                <fa-icon icon="times"></fa-icon>
            </span>
        </a>
    </div>

    <app-loading-screen #searchbymethodloader [loading]="false"></app-loading-screen>
</div>